import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { axiosInstance } from '../config';
import LoadingSpinner from '../components/LoadingSpinner';
import { startGoogleSignIn } from '../utils/googleAuth';
import '../styles/auth.css';

const cookies = new Cookies();

const McpConnect = () => {
    const [searchParams] = useSearchParams();
    const code = searchParams.get('code');
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!code) {
            setStatus('error');
            setMessage('Missing connection code.');
            return;
        }

        const token = cookies.get('access_token') || localStorage.getItem('auth_token');
        if (!token) {
            setStatus('login');
            return;
        }

        axiosInstance
            .post(`/mcp/session/${code}/authorize`)
            .then(({ data }) => {
                setStatus('done');
                setMessage(data.message || 'Connected! Return to your AI assistant.');
            })
            .catch((err) => {
                if (err.response?.status === 401) {
                    setStatus('login');
                    return;
                }
                setStatus('error');
                setMessage(err.response?.data?.message || 'Could not authorize MCP session.');
            });
    }, [code]);

    if (status === 'loading') {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <LoadingSpinner message="Connecting…" />
            </div>
        );
    }

    if (status === 'login') {
        const loginRedirect = `/mcp/connect?code=${encodeURIComponent(code || '')}`;
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
                <div className="max-w-md text-center bg-white rounded-xl shadow-lg p-8">
                    <h1 className="text-xl font-semibold mb-2">Sign in to What To Make</h1>
                    <p className="text-gray-600 mb-6">Sign in to connect your AI assistant.</p>
                    <button
                        type="button"
                        className="google-signin-btn w-full mb-4"
                        onClick={() => startGoogleSignIn(loginRedirect)}
                    >
                        <img src="https://developers.google.com/identity/images/g-logo.png" alt="Google logo" />
                        Sign in with Google
                    </button>
                    <Link
                        to={`/auth/login?redirect=${encodeURIComponent(loginRedirect)}`}
                        className="inline-block text-sm text-gray-600 hover:text-gray-800"
                    >
                        Sign in with email instead
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
            <div className="max-w-md text-center bg-white rounded-xl shadow-lg p-8">
                <h1 className={`text-xl font-semibold mb-2 ${status === 'done' ? 'text-green-700' : 'text-red-700'}`}>
                    {status === 'done' ? 'Connected' : 'Connection failed'}
                </h1>
                <p className="text-gray-600">{message}</p>
            </div>
        </div>
    );
};

export default McpConnect;
